import {
    useEffect,
    type FC,
    useRef
} from "react";
import {
    Animated,
    View
} from "react-native";
import type ITabsSlideProps from "./type";
import stylesheet from "./stylesheet";
import type {
    TabsRect
} from "../../type";
import rootStylesheet from "../../stylesheet";

const TabsSlide: FC<ITabsSlideProps> = ({
    orientation,
    thumbStyle,
    markStyle,
    duration,
    variant,
    easing,
    onEnd,
    slide
}) => {
    const progress = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        progress.setValue(0);

        const animation = Animated.timing(progress, {
            useNativeDriver: false,
            toValue: 1,
            duration,
            easing
        });

        animation.start(({
            finished
        }) => {
            if(finished) {
                onEnd();
            }
        });

        return () => {
            animation.stop();
        };
    }, [
        slide
    ]);

    const getRange = (key: keyof TabsRect) => progress.interpolate({
        outputRange: [
            slide.fromRect[key],
            slide.toRect[key]
        ],
        inputRange: [
            0,
            1
        ]
    });

    const markBaseStyle = variant === "segment" ? rootStylesheet.ring : orientation === "vertical" ? rootStylesheet.barVertical : rootStylesheet.bar;

    return <Animated.View
        style={[
            stylesheet.container,
            thumbStyle,
            {
                height: getRange("height"),
                width: getRange("width"),
                left: getRange("x"),
                top: getRange("y")
            }
        ]}
        aria-hidden={true}
    >
        <View
            style={[
                markBaseStyle,
                markStyle
            ]}
        />
    </Animated.View>;
};
export default TabsSlide;
